import { Graphics, LINE_JOIN, MSAA_QUALITY, Sprite } from 'pixi.js';
import { useEffect, useState } from 'react';
import { useEditorContext } from 'flow-builder/editor.context';
import { HighlightType } from 'flow-builder/types/node';
import { LINE_CAP } from 'flow-builder/types/pixi';
import { styles as commonStyles } from '../common/commonStyles';
import { getIconTextures } from '../utils/icons';
import { styles } from './nodeArrowStyles';
const textureGenerationSettings = {
    resolution: window.devicePixelRatio * 2,
    multisample: MSAA_QUALITY.HIGH,
};
export const useArrowTextures = () => {
    const { view } = useEditorContext();
    const [textures, setTextures] = useState(null);
    useEffect(() => {
        if (!view.isReady) {
            return;
        }
        getIconTextures(['cut', 'lock']).then(({ cut: cutIcon, lock: lockIcon }) => {
            const drawArrow = (color) => {
                const arrow = new Graphics();
                const arrowSize = styles._connectionArrow.size;
                arrow.beginFill(styles._connectionArrow.fill);
                arrow.lineStyle(styles._connectionArrow.width, color);
                arrow.line.join = LINE_JOIN.ROUND;
                arrow.line.cap = LINE_CAP.ROUND;
                arrow.moveTo(0, 0);
                arrow
                    .lineTo(arrowSize, 0)
                    .lineTo(arrowSize / 2, arrowSize)
                    .lineTo(0, 0);
                arrow.endFill();
                return arrow;
            };
            const drawDisconnect = (color) => {
                const disconnect = new Graphics();
                const cut = new Sprite(cutIcon);
                cut.width = 18;
                cut.height = 18;
                cut.anchor.set(0.5, 0.5);
                disconnect.beginFill(styles._disconnectCircle.fill);
                disconnect.lineStyle(styles._disconnectCircle.width, color);
                disconnect.drawCircle(0, 0, styles._disconnectCircle.radius);
                disconnect.endFill();
                disconnect.addChild(cut);
                return disconnect;
            };
            const drawLocked = () => {
                const locked = new Graphics();
                const lock = new Sprite(lockIcon);
                lock.width = 18;
                lock.height = 18;
                lock.anchor.set(0.5, 0.5);
                locked.beginFill(styles._lockedCircle.fill);
                locked.lineStyle(styles._lockedCircle.width, styles._lockedCircle.border);
                locked.drawCircle(0, 0, styles._lockedCircle.radius);
                locked.endFill();
                locked.addChild(lock);
                return locked;
            };
            const generateHighlightTextures = (drawFunc, defaultColor) => ({
                [HighlightType.NONE]: view.app.renderer.generateTexture(drawFunc(defaultColor), textureGenerationSettings),
                [HighlightType.INFO]: view.app.renderer.generateTexture(drawFunc(commonStyles.highlight[HighlightType.INFO]), textureGenerationSettings),
                [HighlightType.ERROR]: view.app.renderer.generateTexture(drawFunc(commonStyles.highlight[HighlightType.ERROR]), textureGenerationSettings),
            });
            const arrow = generateHighlightTextures(drawArrow, styles._connectionArrow.color);
            const disconnect = generateHighlightTextures(drawDisconnect, styles._disconnectCircle.border);
            const locked = generateHighlightTextures(drawLocked, styles._lockedCircle.border);
            setTextures({
                arrow,
                disconnect,
                locked,
            });
        });
    }, [view.isReady, view.app, setTextures]);
    return textures;
};
